<template>
  <div class="animated fadeIn">

    
    <b-card class="card-accent-info" header="Inventário">
      <b-card-body>

        <b-row>
          <b-col cols="auto" class="mr-auto">
              <!--
              <b-form-group>
                  <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
            </b-form-group>
            -->
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group>
              <!--
              <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
              &nbsp;
              -->
              <b-button variant="twitter" class="mr-1 btn-brand" @click="exportProductsFile()" :disabled="isExportingProducts"><i class="fa fa-file-code-o"></i><span v-if="!isExportingProducts">Exportar Produtos</span><span v-else><b-spinner small></b-spinner> Exportando...</span></b-button>
              <b-button variant="behance" class="mr-1 btn-brand" @click="exportUsersFile()" :disabled="isExportingUsers"><i class="fa fa-file-code-o"></i><span v-if="!isExportingUsers">Exportar Usuários</span><span v-else><b-spinner small></b-spinner> Exportando...</span></b-button>
              <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Inventário</span></b-button>
            </b-form-group>
          </b-col>
        </b-row>
            

        <b-row>
          <b-col cols="auto">
            <b-form-group>
                <label for="company" style="font-size: 0.8em">Empresa</label>
                <b-form-select id="company"
                  v-model="filters.companyId"
                  :plain="true"
                  :options="companyDDL"
                  @change="refreshData"
                  :value="[null,'c']">
                </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>
      
          <b-col cols="auto">
            <b-form-group>
                <label for="statusId" style="font-size: 0.8em">Status</label>
                <b-form-select id="statusId"
                  v-model="filters.statusId"
                  :plain="true"
                  :options="selectStatusDDL">
                </b-form-select>
            </b-form-group>
          </b-col>

        
          <b-col cols="auto">

            <b-form-group>
                <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                <b-form-select id="status"
                  v-model="filters.status"
                  :plain="true"
                  :options="statusddl"
                  :value="[null,'c']">
                </b-form-select>
            </b-form-group>
          </b-col>


          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>
      

          <b-table
              :items="filteredItems"
              :fields="fields"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              @row-clicked="rowClicked"
              :primary-key="primaryKey"
              :tbody-transition-props="transProps"
              sort-icon-left
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              hover
              striped

              >

              <template #table-busy>
                  <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Carregando...</strong>
                  </div>
              </template>
              
              <!-- Example scoped slot for select state illustrative purposes -->
              <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                  </template>
              </template>

              <template #cell(show_details)="row">
                  <b-row>
                      <b-col cols="auto" class="mr-auto">
                          <b-form-group>
                          <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                          </b-form-group>
                      </b-col>
                  </b-row>
              </template>
              
              <template #row-details="row">
                  <b-card>
                      <b-row v-show="row.item.summary && row.item.summary.length > 0">
                          <b-col class="small">Resumo</b-col>
                      </b-row>
                      <b-row>
                          <b-col class="text-primary">{{ row.item.summary }}</b-col>
                      </b-row>
                      <b-row v-show="row.item.content && row.item.content.length > 0">
                          <b-col class="small">Conteúdo</b-col>
                      </b-row>
                      <b-row>
                          <b-col class="text-primary">{{ row.item.content }}</b-col>
                      </b-row>
                      <b-row>
                          <b-col>{{ row.item.content }}</b-col>
                      </b-row>
                      <b-row>
                          <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                      </b-row>
                  </b-card>
              </template>
              
              <template v-slot:cell(originalValue)="data">
                  {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
              </template>

              <template v-slot:cell(paymentValue)="data">
                  {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
              </template>

              <template v-slot:cell(costcenter)="data">
                  {{ data.item.costCenterCode  }}<br>{{ data.item.costCenterName }}
              </template>

              <template v-slot:cell(startDate)="data">
                  {{ $utils.dateStringFormat(data.item.startDate) }}
              </template>

              <template v-slot:cell(endDate)="data">
                  {{ $utils.dateStringFormat(data.item.endDate) }}
              </template>

              <template v-slot:cell(labelRange)="data">
                  <span v-if="data.item.labelStart || data.item.labelEnd">{{ data.item.labelStart }} - {{ data.item.labelEnd }}</span>
              </template>

              <template v-slot:cell(sectorLabelRange)="data">
                  <b-spinner small variant="primary" v-if="data.item.sectorLabelMin === undefined"></b-spinner>
                  <span v-else-if="data.item.sectorLabelMin !== null">{{ data.item.sectorLabelMin }} - {{ data.item.sectorLabelMax }}</span>
                  <span v-else class="text-muted">-</span>
              </template>


              <template v-slot:cell(st)="data">
                  <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>
              
              <template v-slot:cell(ispublic)="data">
                  <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>
              
              <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="twitter" @click="exportBlank(data.item)" class="mr-1 btn-brand" title="Exportar Em Branco" style="margin-bottom: 4px">
                    <i class="fa fa-square-o"></i></b-button>
                    <b-button size="sm" variant="behance" @click="exportCancel(data.item)" class="mr-1 btn-brand" title="Exportar Cancelados" style="margin-bottom: 4px">
                    <i class="fa fa-window-close-o"></i></b-button>
                    <b-button size="sm" variant="primary" @click="exportOracle(data.item)" class="mr-1 btn-brand" title="Exportar Oracle" style="margin-bottom: 4px">
                    <i class="fa fa-file-excel-o"></i></b-button>
                    <b-button size="sm" variant="css3" @click="exportOracleUSA(data.item)" class="mr-1 btn-brand" title="Exportar Oracle USA" style="margin-bottom: 4px">
                    <i class="fa fa-external-link"></i></b-button>

                    <b-button size="sm" variant="spotify" @click="openPrintModal(data.item)" class="mr-1 btn-brand" title="Imprimir Etiqueta" style="margin-bottom: 4px">
                    <i class="fa fa-print"></i></b-button>
                    
                    
              </template>
              
          </b-table>
          <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
          </nav>


      </b-card-body>
   </b-card>

   <b-modal
            v-model="printModal"
            id="print-modal"
            centered
            hide-footer
            title="Etiquetas"
            size="xl">

            <inventory-print-component
              :inventoryId="selectedItem.id"
              :item="selectedItem"
            ></inventory-print-component>

   </b-modal>

   <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Inventário"
            size="lg">

    <b-nav fill>
      <b-nav-item :active="tabInfo=='I'" @click="tabInfo='I'">Inventário</b-nav-item>
      <b-nav-item :active="tabInfo=='S'" @click="tabInfo='S'">Setores</b-nav-item>
    </b-nav>

    

    <div v-show="tabInfo=='I'">
      <b-card> 

      <b-form @submit.stop.prevent="onSubmit">

      <div class="animated fadeIn">
    
        <b-row>
          <b-col>
            <b-form>
              <b-form-group
              description=""
              label="Inventário"
              label-for="inventoryName"
              :label-cols="3"
              :horizontal="true">
              

                <b-row>
                  <b-col>
                      <b-form-input v-model="selectedItem.name" id="inventoryName" type="text"></b-form-input>
                  </b-col>
                                    
                </b-row>

              </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form>
              <b-form-group
                    label="Período"
                    label-for="startDate"
                    :label-cols="3"
                    :horizontal="true">
                    <b-row>
                      <b-col cols="4">
                        <b-form-input v-model="selectedItem.startDate" type="date" id="startDate"></b-form-input>
                      </b-col>
                      <b-col cols="4">
                        <b-form-input v-model="selectedItem.endDate" type="date" id="endDate"></b-form-input>
                      </b-col>                     
                    </b-row>
                    
                  </b-form-group>                  
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form>
              <b-form-group
              description=""
              label="Faixa de números"
              label-for="labelStart"
              :label-cols="3"
              :horizontal="true">
                <b-row>
                  <b-col lg="4">
                      <b-form-input v-model="selectedItem.labelStart" id="labelStart" type="number"></b-form-input>
                  </b-col>
                  <b-col lg="4">
                      <b-form-input v-model="selectedItem.labelEnd" id="labelEnd" type="number"></b-form-input>
                  </b-col>
                </b-row>
              </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <hr>

        <b-row>
          <b-col>
            <b-form>
              <b-form-group
              description=""
              label="Prefixo da Etiqueta"
              label-for="labelNumberPrefix"
              :label-cols="3"
              :horizontal="true">
                <b-row>
                  <b-col lg="4">
                      <b-form-input v-model="selectedItem.labelNumberPrefix" id="labelNumberPrefix" type="text" maxLength="5"></b-form-input>
                  </b-col>                                    
                </b-row>
              </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form>
              <b-form-group
              description="Quantidade de dígitos desconsiderando o prefixo. Ex: P12345 = 5"
              label="Dígitos da Etiqueta"
              label-for="labelNumberLength"
              :label-cols="3"
              :horizontal="true">
                <b-row>
                  <b-col lg="4">
                      <b-form-input v-model="selectedItem.labelNumberLength" id="labelNumberLength" type="number" maxLength="2"></b-form-input>
                  </b-col>                                    
                </b-row>
              </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form>
              <b-form-group
              description="Expressão regular para máscara de código da Etiqueta. Ex: ^P\d{5}$"
              label="Máscara da Etiqueta"
              label-for="labelIdRegex"
              :label-cols="3"
              :horizontal="true">
                <b-row>
                  <b-col>
                      <b-form-input v-model="selectedItem.labelIdRegex" id="labelIdRegex" type="text"></b-form-input>
                  </b-col>                                    
                </b-row>
              </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <hr>

        <b-row>
          <b-col>
            <b-form>
              <b-form-group
              description="Modelo do arquivo de etiqueta"
              label="Modelo de Etiqueta"
              label-for="labelTemplatePath"
              :label-cols="3"
              :horizontal="true">
                <b-row>
                  <b-col>
                      <b-form-input v-model="selectedItem.labelTemplatePath" id="labelTemplatePath" type="text"></b-form-input>
                  </b-col>                                    
                </b-row>
              </b-form-group>          
            </b-form>
          </b-col>
        </b-row>


        <!--
        <b-row>
          <b-col md="12">
            <b-form>
              <b-form-group
                    label="Data de término"
                    label-for="endDate"
                    :label-cols="3"
                    :horizontal="true">
                    <b-row>                      
                      <b-col cols="4">
                        <b-form-input v-model="selectedItem.endDate" type="date" id="endDate"></b-form-input>
                      </b-col>
                    </b-row>
                    
                  </b-form-group>                  
            </b-form>
          </b-col>
        </b-row>
-->
        

        <b-input-group class="mb-4">
            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
        </b-input-group>
      
        <div slot="footer" class="text-right">
          <!--
          <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
          <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
          -->
          <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Inventário</span></b-button>
         
        </div>
              
      </div>
      </b-form>
    
    </b-card>
    </div>

    <div v-show="tabInfo=='S'">
      <b-card>
          <inventory-sector-label-grid-component :inventory="selectedItem" :companyId="filters.companyId">
          </inventory-sector-label-grid-component>
      </b-card>
    </div>

    </b-modal>

  </div>

</template>

<script>
import Vue from 'vue'
import axios from "axios";

import { Switch as cSwitch } from '@coreui/vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'
import InventoryPrintComponent from './InventoryPrintComponent';
import InventorySectorLabelGridComponent from './InventorySectorLabelGridComponent'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}

export default {
  name: 'tables',
  components: {
    Event,
    cSwitch,
    InventoryPrintComponent,
    InventorySectorLabelGridComponent
  },
  data: () => {
    return {
      tabInfo: 'I',
      statusDDL: [],
      statusddl: [
        {
          text: '- Todos -',
          value: 0
        },
        {
          text: 'Ativo',
          value: 'A'
        },
        {
          text: 'Inativo',
          value: 'I'
        }
      ],
      companyDDL: [],

      isBusy: false,
      isExportingProducts: false,
      isExportingUsers: false,
      currentPage: 1,
      switchLabelIcon: {
          dataOn: '\u2713',
          dataOff: '\u2715'
      },
      switchLabelTxt: {
          dataOn: 'yes',
          dataOff: 'no'
      },

      tableRef: "table",
      tableSelectable: false,
      errorMessage: '',
      editModal: false,
      printModal: false,
      filters: {
        companyId: null,
        key: '',
        status: 0
      },

      modes: ['multi', 'single', 'range'],
      selectMode: 'multi',
      selected: [],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      primaryKey: "id",

      selectedItem: newItem,
      items: [        
      ],
      fields: [
        //{key: 'show_details', label: "", thStyle: { width: "40px" } },
        {key: 'id', label: 'Id', sortable: true, thStyle: { width: "80px" }, class: 'text-center' },
        //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
        {key: 'name', label: 'Inventário', sortable: true },
        {key: 'startDate', label: 'Início', sortable: true, thStyle: { width: "150px" }, class: 'text-center' },
        {key: 'endDate', label: 'Término', sortable: true, thStyle: { width: "150px" }, class: 'text-center' },
        {key: 'labelRange', label: 'Faixa de números', sortable: false, thStyle: { width: "150px" }, class: 'text-center' },
        {key: 'sectorLabelRange', label: 'Faixa Alocada nos Setores', sortable: false, thStyle: { width: "170px" }, class: 'text-center' },
        //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
        //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
        //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
        //{key: 'description', label: 'Descrição', sortable: false },
        //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
        {key: 'status.name', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
        {key: 'st', label: 'Ativo', sortable: true, thStyle: { width: "40px" } },
        {key: 'action', label: '', sortable: false, class: 'text-center', thStyle: { width: "200px" } }
      ],
      
      filterable: ['username'],
      sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
      perPage: 20
    }
  },
  computed: {
    selectStatusDDL: function() {
        var list = [...this.statusDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        /* list.unshift({ value: '0' , text: '- Todos -' }) */
        return list
    },
    totalRows: function () { return this.getRowCount() },
    filteredItems() {
      try {
          return this.items.filter(item => {
            return (this.filters.key == '' || (
                this.$utils.filterString(item.name, this.filters.key)
                //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                ))
                && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                && (this.filters.statusId==0 || (item.status && item.status.id == this.filters.statusId) )              
          })
      }
      catch(e) {
          return this.items;
      }
    }
  },
  methods: {

    getRowCount: function () {
      if(this.items)
          return this.items.length
      else
          return 0;
    },
    

    changeStatus(item) {
      if(item != null) {
        if(item.st == 'A') 
          item.st = 'I'; 
        else 
          item.st = 'A';
        this.saveItem(item);
      }
    },

    async saveItem(currentItem) {

      var s = this;
      var postData = {...currentItem};

      postData["companyId"] = s.filters.companyId
      postData["uid"] = this.$store.state.currentUser.id,
      postData["sid"] = this.$store.state.currentUser.sid
      postData["startDate"] = postData["startDate"] ? (postData["startDate"].length <= 10 ? postData["startDate"] + "T12:00:00" : postData["startDate"]) : null
      postData["endDate"] = postData["endDate"] ? (postData["endDate"].length <= 10 ? postData["endDate"] + "T12:00:00" : postData["endDate"]) : null
      
     
      await axios.post(
          this.$store.state.ws_url + "/stock/inventory",
          postData
      ).then(function() {
          s.closeEditModal()
          s.refreshData();
      }
      ).catch(function (error) {
          console.log(error.response.data.message);

          toast ({
              type: VueNotifications.types.warn,
              title: 'Inventário',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
          })        
      });

  },

  save() {

      let msgError = [];

      if(this.selectedItem.name.length <= 2)
          msgError.push("Inventário");
      
      if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
              type: VueNotifications.types.error,
              title: 'Inventário',
              message: msgErrorExt,
              timeout: 5000
          })
      }
      else {
          this.saveItem(this.selectedItem);
      }
  },

    enableDisable() {
      console.log('Habilitando/desabilitando modelo')
      console.log(this.selectedItem);
    },

    openPrintModal(item) {
      this.selectedItem = { ...item };
      this.printModal = true
    },
    closePrintModal() {
      this.printModal = false
    },

    closeEditModal() {
      this.editModal = false;
    },
    openEditModal(item) {
      this.tabInfo = 'I'
      if(item == null) {
          this.selectedItem = { ...newItem };      
      }
      else {
          this.selectedItem = { ...item };
      }

      this.selectedItem.companyId = this.filters.companyId

      this.editModal = true;
    },
    onRowSelected(items) {
      this.selected = items       
    },
    rowClicked(item) {
      if(!this.tableSelectable) {
          this.clearSelectedRows();
          this.openEditModal(item);
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelectedRows() {
      this.$refs.selectableTable.clearSelected();
    },
    
    getBadge (status) {
      return status === 'A' ? 'primary'
          : status === 'I' ? 'danger'
          : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
    },

    async exportBlank(item) {
      var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
            this.$store.state.ws_url + "/inventory/export/text?exportId=5&inventoryId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {

          const blob = new Blob([resp.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'export_blank_' + item.id + '_' + new Date().toISOString().split('T')[0] + '.txt'
        link.click()
        URL.revokeObjectURL(link.href)

            toast ({
                  type: VueNotifications.types.info,
                  title: 'Exportação',
                  message: 'Exportação etiquetas em branco gerada com sucesso.',
                  timeout: 5000
              })
        })            
        .catch(function(error) {
            console.log(error);
            toast ({
                  type: VueNotifications.types.error,
                  title: 'Exportação',
                  message: 'Erro ao exportar.',
                  timeout: 5000
              })
        });
    },

    async exportCancel(item) {
      var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
            this.$store.state.ws_url + "/inventory/export/text?exportId=4&inventoryId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {

          const blob = new Blob([resp.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'export_cancel_' + item.id + '_' + new Date().toISOString().split('T')[0] + '.txt'
        link.click()
        URL.revokeObjectURL(link.href)

            toast ({
                  type: VueNotifications.types.info,
                  title: 'Exportação',
                  message: 'Exportação etiquetas canceladas gerada com sucesso.',
                  timeout: 5000
              })
        })            
        .catch(function(error) {
            console.log(error);
            toast ({
                  type: VueNotifications.types.error,
                  title: 'Exportação',
                  message: 'Erro ao exportar.',
                  timeout: 5000
              })
        });
    },

    async exportOracleUSA(item) {
      var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
            this.$store.state.ws_url + "/inventory/export/text?exportId=1&separator=,&inventoryId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {

          const blob = new Blob([resp.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'export_oracle_us_' + item.id + '_' + new Date().toISOString().split('T')[0] + '.txt'
        link.click()
        URL.revokeObjectURL(link.href)

            toast ({
                  type: VueNotifications.types.info,
                  title: 'Exportação',
                  message: 'Exportação Oracle gerada com sucesso.',
                  timeout: 5000
              })
        })            
        .catch(function(error) {
            console.log(error);
            toast ({
                  type: VueNotifications.types.error,
                  title: 'Exportação',
                  message: 'Erro ao exportar.',
                  timeout: 5000
              })
        });
    },

    async exportOracle(item) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
            this.$store.state.ws_url + "/inventory/export/text?exportId=2&inventoryId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {

          const blob = new Blob([resp.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'export_oracle_' + item.id + '_' + new Date().toISOString().split('T')[0] + '.txt'
        link.click()
        URL.revokeObjectURL(link.href)

            toast ({
                  type: VueNotifications.types.info,
                  title: 'Exportação',
                  message: 'Exportação Oracle gerada com sucesso.',
                  timeout: 5000
              })
        })            
        .catch(function(error) {
            console.log(error);
            toast ({
                  type: VueNotifications.types.error,
                  title: 'Exportação',
                  message: 'Erro ao exportar.',
                  timeout: 5000
              })
        });
          
    },

    async generateInventoryFile(entity, label) {
      await axios.get(
          this.$store.state.ws_url + "/app/inventory/" + entity + "/generate"
      ).then(function(resp) {

        toast ({
              type: VueNotifications.types.info,
              title: 'Exportação',
              message: label + ' exportado(s) com sucesso: ' + resp.data.obj + ' registro(s).',
              timeout: 5000
          })
      })
      .catch(function(error) {
          console.log(error);
          toast ({
                type: VueNotifications.types.error,
                title: 'Exportação',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Erro ao exportar.',
                timeout: 5000
            })
      });
    },

    async exportProductsFile() {
      this.isExportingProducts = true
      await this.generateInventoryFile('product', 'Produtos')
      this.isExportingProducts = false
    },

    async exportUsersFile() {
      this.isExportingUsers = true
      await this.generateInventoryFile('user', 'Usuários')
      this.isExportingUsers = false
    },

    async getStatus() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          //console.log( this.$store.state.ws_url + "/inventory/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid)
          await axios.get(
              this.$store.state.ws_url + "/inventory/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.statusDDL = resp.data.obj;
          })            
          .catch(function(error) {
              console.log(error);
          });
          
      }, 

    async refreshData() {

          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/stock/inventory?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.items = resp.data.obj;
              s.loadSectorLabelRanges();
          }
          ).catch(function (error) {
              toast ({
                  type: VueNotifications.types.error,
                  title: 'Inventário',
                  message: 'Sem permissão de acesso. Verifique e tente novamente.',
                  timeout: 3000
              })
          });

          this.isBusy = false;

    },

    // Busca, para cada inventário, a menor/maior etiqueta alocada entre os setores.
    // Uma chamada por inventário, todas em paralelo (não bloqueia a exibição da tabela).
    async loadSectorLabelRanges() {
      var s = this;
      var currentUser = this.$store.state.currentUser;

      await Promise.all(this.items.map(function(item) {
        return axios.get(
            s.$store.state.ws_url + "/stock/location/label?inventoryId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          var labels = resp.data.obj || [];
          var min = null;
          var max = null;

          labels.forEach(function(label) {
            if(label.labelStart !== null && label.labelStart !== undefined && (min === null || label.labelStart < min)) {
              min = label.labelStart;
            }
            if(label.labelEnd !== null && label.labelEnd !== undefined && (max === null || label.labelEnd > max)) {
              max = label.labelEnd;
            }
          });

          s.$set(item, 'sectorLabelMin', min);
          s.$set(item, 'sectorLabelMax', max);
        }).catch(function() {
          s.$set(item, 'sectorLabelMin', null);
          s.$set(item, 'sectorLabelMax', null);
        });
      }));
    }
  },
  mounted: function() {
    this.filters.statusId = 0
    this.filters.status = 'A'
    this.companyDDL = this.$store.state.currentUser.companies
    this.filters.companyId = this.$store.state.currentUser.companyId

    this.getStatus();
    this.refreshData();
  }
}
</script>

<style scoped>
table#table-transition-example .flip-list-move {
transition: transform 1s;
}
</style>